import React from 'react';
import LogHourCard from '../LogHourCard';

interface LoggedHoursDashboardListProps {
  data?: any[];
}

const LoggedHoursDashboardList: React.FC<LoggedHoursDashboardListProps> = ({ data }) => {


  return (
    <div className="property-listing-container">
      <h2 className="section-title">Logged Hours</h2>

      {(data && data?.length > 0) ? (
        <div className="properties-grid">
          {data?.map((property: any, index: any) => (
            <LogHourCard
              key={index}
              main_category={property?.main_category}
              sub_activity={property?.sub_activity}
              hours={property?.hours}
              minutes={property?.minutes}
              property_name={property?.property?.name}
              activity={property?.activity}
              user={property?.user}
              cpa_comment={property?.cpa_comment}
              status={property?.status}
              reason={property?.reason}
            />
          ))}
        </div>
      ) : (
        <p className="text-center w-100 py-4">No data found.</p>
      )}

    </div>
  );
};

export default LoggedHoursDashboardList;